<template>
  <el-carousel :interval="5000" class="banner-carousel">
    <el-carousel-item v-for="(item, index) in contentList" :key="index" class="banner-container">
      <img v-if="item.webImageUri" :src="getImageUrl(item.webImageUri)" @click="newPage(item.targetUrl)">
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import { commonUtils } from '@/utils/common'
import itemApi from '@/api/item'
export default {
  name: 'BannerCarousel',
  data () {
    return {
      contentList: []
    }
  },
  mounted () {
    this.getBannerList()
  },
  methods: {
    getBannerList () {
      const params = {
        useScope: 'web',
        contentType: '01'
      }
      itemApi.queryBannerList(params).then(response => {
        this.contentList = response.data.resultData.contentList
      })
    },
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    newPage (url) {
        if(url != "") {
          window.open(url, '_blank')
        }
    }
  }
}

</script>

<style lang="scss" scoped>
.banner-carousel {
  height: 380px;
  width: 100%;
  overflow: hidden;
  /deep/ .el-carousel__container {
    height: 100%;
  }
}
.banner-container {
  max-height: 600px;
  overflow: hidden;
  cursor: pointer;
  img {
    width: 100%;
  }
}
</style>
